<template>
  <o-grid
    :class="[
      $s.Section,
      {
        [$s.bordered]: bordered,
      },
    ]"
  >
    <o-grid-item
      v-for="(column, index) in section"
      :key="index"
      :span="12"
      :tablet-landscape="desktopSpacing"
      :big-desktop="desktopSpacing"
    >
      <feature-section-content :column="column" />
    </o-grid-item>
  </o-grid>
</template>

<script>
import { OGrid, OGridItem } from 'orbit-ui/components/Grid';

import FeatureSectionContent from './FeatureSectionContent.vue';

const Section = {
  name: 'FeatureSection',

  components: {
    FeatureSectionContent,
    OGrid,
    OGridItem,
  },

  props: {
    section: {
      type: Array,
      default: () => ({}),
    },
    bordered: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    desktopSpacing() {
      return this.section.length > 1 ? 6 : 12;
    },
  },
};

export default Section;
</script>

<style module="$s" lang="scss">
.Section {
  padding: var(--space-x4) 0;

  p:last-child {
    margin-bottom: 0;
  }
}

.flush {
  margin: 0;
}

.bordered {
  border-bottom: 1px solid var(--color-gray-20);
}
</style>
